import { useQuery } from '@tanstack/react-query'
import { getCurrentUser } from '@/utils/auth/UserProvider'
import { getEffectiveOrgUuid } from '@/utils/utils'
import { useToken } from './useToken'
import { loadProgress } from '../api/onboardingProgressAPI'

/**
 * Lightweight hook for checking whether the current org is mid-onboarding.
 * Used by the main app nav to show "Finish Onboarding" button.
 */
export function useOnboardingStatus() {
  const { getToken } = useToken()
  const { user, orgs } = getCurrentUser()
  const orgUuid = getEffectiveOrgUuid(user, orgs) || null

  const { data, isLoading } = useQuery({
    queryKey: ['onboarding-status', orgUuid],
    queryFn: async () => {
      if (!orgUuid) return null
      const token = await getToken()
      try {
        return await loadProgress(token, orgUuid)
      } catch {
        return null
      }
    },
    enabled: !!orgUuid,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  return {
    isOnboarding: !!data && !data.is_complete,
    isOnboardingComplete: data?.is_complete === true,
    isLoading,
  }
}
